/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type EvalArtifactsObject = {
  object: "eval.artifacts";
  runId: string;
  resultFileId: string | null;
  samplesFileId: string | null;
  artifactFileIds: Array<string>;
};

/** @internal */
export const EvalArtifactsObject$inboundSchema: z.ZodType<
  EvalArtifactsObject,
  z.ZodTypeDef,
  unknown
> = z.object({
  object: z.literal("eval.artifacts"),
  run_id: z.string(),
  result_file_id: z.nullable(z.string()),
  samples_file_id: z.nullable(z.string()),
  artifact_file_ids: z.array(z.string()),
}).transform((v) => {
  return remap$(v, {
    "run_id": "runId",
    "result_file_id": "resultFileId",
    "samples_file_id": "samplesFileId",
    "artifact_file_ids": "artifactFileIds",
  });
});
/** @internal */
export type EvalArtifactsObject$Outbound = {
  object: "eval.artifacts";
  run_id: string;
  result_file_id: string | null;
  samples_file_id: string | null;
  artifact_file_ids: Array<string>;
};

/** @internal */
export const EvalArtifactsObject$outboundSchema: z.ZodType<
  EvalArtifactsObject$Outbound,
  z.ZodTypeDef,
  EvalArtifactsObject
> = z.object({
  object: z.literal("eval.artifacts"),
  runId: z.string(),
  resultFileId: z.nullable(z.string()),
  samplesFileId: z.nullable(z.string()),
  artifactFileIds: z.array(z.string()),
}).transform((v) => {
  return remap$(v, {
    runId: "run_id",
    resultFileId: "result_file_id",
    samplesFileId: "samples_file_id",
    artifactFileIds: "artifact_file_ids",
  });
});

export function evalArtifactsObjectToJSON(
  evalArtifactsObject: EvalArtifactsObject,
): string {
  return JSON.stringify(
    EvalArtifactsObject$outboundSchema.parse(evalArtifactsObject),
  );
}
export function evalArtifactsObjectFromJSON(
  jsonString: string,
): SafeParseResult<EvalArtifactsObject, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => EvalArtifactsObject$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'EvalArtifactsObject' from JSON`,
  );
}
